import React from 'react';
import { 
  Target,
  Calendar,
  FileText,
  Zap,
  Brain
} from 'lucide-react';

const NovStatusReport = () => {
  return (
    <div className="status-report">
      <div className="report-header">
        <h1 className="report-title">
          <Calendar className="w-8 h-8 text-blue-600" />
          AI Team Status Report - Last Two Weeks
        </h1>
        <div className="report-meta">
          <span className="meta-item">
            <Calendar className="w-4 h-4" />
            December 2025
          </span>
          <span className="meta-item">
            <Target className="w-4 h-4" />
            Status Update
          </span>
        </div>
      </div>

      <div className="report-grid">
        {/* Asuretify Section */}
        <div className="report-section">
          <h2 className="section-title">
            <Brain className="w-6 h-6 text-purple-600" />
            Asuretify
          </h2>
          
          <div className="achievement-cards">
            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Model Performance Analysis</h3>
                <span className="status-badge completed">COMPLETED</span>
              </div>
              <ul className="achievement-list">
                <li>BERT-1 (4-class) performs better overall</li>
                <li>Analysis of BERT model predictions completed</li>
                <li>Model comparison and evaluation finalized</li>
              </ul>
            </div>

            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Endorsement Page Detection</h3>
                <span className="status-badge completed">IN PROGRESS</span>
              </div>
              <ul className="achievement-list">
                <li>Regex-based logic applied on BERT Other class working effectively</li>
                <li>Tested on 160 files, doing more every day</li>
                <li>Nearly ~95%  accuracy</li>
              </ul>
            </div>

            <div className="achievement-card">
              <div className="achievement-header">
                <h3>LLMWhisperer Integration</h3>
                <span className="status-badge in-progress">IN PROGRESS</span>
              </div>
              <ul className="achievement-list">
                <li>Working on integrating LLMWhisperer to replace YOLO model</li>
                <li>Target: Enhanced endorsement pages detection</li>
              </ul>
            </div>

            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Endorsement Field Extraction</h3>
                <span className="status-badge in-progress">IN PROGRESS</span>
              </div>
              <ul className="achievement-list">
                <li>Initial exploration started using 4o-mini and 4.1-mini</li>
                <li>Early results: 4.1-mini performs better without LangExtract</li>
                <li>LangExtract taking comparatively more time for extraction. 35-40 seconds more than current approach</li>
                <li>Further prompting and testing required before finalizing approach</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Kinetic Section */}
        <div className="report-section">
          <h2 className="section-title">
            <Zap className="w-6 h-6 text-orange-600" />
            Kinetic
          </h2>
          
          <div className="achievement-cards">
            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Pipeline Flow Implementation</h3>
                <span className="status-badge completed">COMPLETED</span>
              </div>
              <ul className="achievement-list">
                <li>Pipeline flow implementation completed</li>
                <li>Core architecture and workflow established</li>
              </ul>
            </div>

            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Testing & Accuracy</h3>
                <span className="status-badge in-progress">IN PROGRESS</span>
              </div>
              <ul className="achievement-list">
                <li>Testing has started</li>
                <li>Prompt improvements required - OpenAI misses some fields in custom field section</li>
                <li>Shows variations in custom fields over multiple hits</li>
                <li>Status: Ongoing refinement</li>
              </ul>
            </div>

            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Checkbox Detection</h3>
                <span className="status-badge in-progress">IN PROGRESS</span>
              </div>
              <ul className="achievement-list">
                <li>Trained YOLO model identified for checkbox detection</li>
                <li>Detects pages containing checkboxes in:</li>
                <li style={{ marginLeft: '20px' }}>• Scanned PDFs</li>
                <li style={{ marginLeft: '20px' }}>• Unscanned PDFs</li>
                <li style={{ marginLeft: '20px' }}>• Word documents</li>
                <li>Excel document handling exploration started today</li>
                <li>Pending: Check extraction and integrate LLMWhisperer API for checkbox detected pages</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Wrap Section */}
        <div className="report-section">
          <h2 className="section-title">
            <FileText className="w-6 h-6 text-green-600" />
            Wrap
          </h2>
          
          <div className="achievement-cards">
            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Archiving</h3>
                <span className="status-badge scheduled">PENDING</span>
              </div>
              <ul className="achievement-list">
                <li>Cleaning old bugs and features archived</li>
              </ul>
            </div>

            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Rate Extraction</h3>
                <span className="status-badge scheduled">STARTING</span>
              </div>
              <ul className="achievement-list">
                <li>Rate page extraction API development</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Summary & Next Steps */}
        {/* <div className="report-section">
          <h2 className="section-title">
            <Target className="w-6 h-6 text-teal-600" />
            Summary & Next Steps
          </h2>
          
          <div className="achievement-cards">
            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Key Achievements</h3>
                <span className="status-badge completed">✓</span>
              </div>
              <ul className="achievement-list">
                <li><strong>Asuretify:</strong> BERT-1 model confirmed, 100 files with 100% accuracy, LLMWhisperer integration started</li>
                <li><strong>Kinetic:</strong> Pipeline flow completed, testing in progress, checkbox detection model identified</li>
                <li><strong>Wrap:</strong> Rate extraction starting</li>
                <li><strong>Testing:</strong> 160 files tested (Asuretify), 3 documents tested (Kinetic), Accuracy: 80-95% (Kinetic)</li>
              </ul>
            </div>

            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Next Steps</h3>
                <span className="status-badge in-progress">ONGOING</span>
              </div>
              <ul className="achievement-list">
                <li><strong>Asuretify:</strong> Complete LLMWhisperer integration, resolve identified failure cases, finalize endorsement field extraction approach</li>
                <li><strong>Kinetic:</strong> Improve prompts for better accuracy, complete checkbox extraction integration, finish Excel document handling</li>
                <li><strong>Wrap:</strong> Begin rate extraction API development, discuss archiving with Adam</li>
              </ul>
            </div>
          </div>
        </div> */}

        {/* Team Updates */}
        {/* <div className="report-section">
          <h2 className="section-title">
            <Users className="w-6 h-6 text-indigo-600" />
            Team Updates
          </h2>
          
          <div className="achievement-cards">
            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Team Members</h3>
                <span className="status-badge completed">ACTIVE</span>
              </div>
              <ul className="achievement-list">
                <li><strong>Bhavya:</strong> Joined team today, working on LLMWhisperer integration</li>
                <li><strong>Sarjil:</strong> Addressing failure cases in endorsement page detection</li>
                <li><strong>Dharmik:</strong> Performing additional testing on endorsement page detection</li>
                <li><strong>Interns:</strong> Completed testing on 160 files</li>
              </ul>
            </div>
          </div>
        </div> */}
      </div>

      <div className="report-footer">
        <p><strong>Prepared by:</strong> Naqi & Claude</p>
        <p><strong>Report Date:</strong> December 2025</p>
        <p><strong>Period:</strong> Last Two Weeks</p>
      </div>
    </div>
  );
};

export default NovStatusReport;

